import { atom } from 'recoil';
import Intervention from 'src/interfaces/api/Intervention';
import Ticket from '../../interfaces/api/Ticket';

export type InterventionState = Intervention & {
  ticketId: Ticket['id'];
};

export default atom({
  key: 'interventions',
  default: {} as { [key: string]: InterventionState },
});
